import axios from "axios";
const TIMEOUT = 30000;
const SERVER_URL = process.env.VUE_APP_IOT_SERVER_URL;
const TOKEN = process.env.VUE_APP_IOT_TOKEN;
export class DigitalWaterMeter {
  constructor() {}
  
  static async getLatestMeterData(partner, type, cust_id, meter_address, datetime) {
    let url = `${SERVER_URL}/api/meter/water/data`;
    let { data } = await axios({
      method: 'get',
      url: url,
      headers: {
        'Authorization': `Bearer ${TOKEN}`,
        'Content-Type': 'application/json',
      },
      params: {
        partner: partner,
        type: type,
        cust_id: cust_id,
        meter_address: meter_address,
        datetime: datetime
      },
      timeout: TIMEOUT,
    });
    let hashData = {}
    for (let key in data.data) {
      let _data = data.data[key]
      hashData[`${data.cust_id}_${key}`] = {
        unit: Math.round(parseFloat(_data.unit)),
        isOffline: _data.isOffline,
        status_unit: _data.status_unit,
        datetime: _data.datetime
      }
    }
    return hashData
  }
}